<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-10 " style="height: 500px;">
      <!-- begin col-4 -->
      <div class="col-xl-12 col-lg-12">
        <!-- begin card -->
        <div
          class="card border-0 mb-3"
          :class="{ 'bg-dark-darker text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b>BALANCE INVENTORY BY WAREHOUSES</b>
              <span class="text-grey ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Balance Inventory By Warehouses"
                  v-b-popover.hover="
                    'Total online store sales that came from a social referrer source.'
                  "
                ></i
              ></span>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label>{{ $t('balanceInventoryByBranch.productGroup') }}</label>
                <a-select
                  style="width: 100%"
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  placeholder="All"
                  v-model="model.pro_group_id"
                  :options="productGroups"
                ></a-select>
              </div>
            </div>
            <!-- end title -->
          </div>
          <!-- end card-body -->
          <!-- begin widget-list -->
          <ts-loading-banner :loading="loading">
            <div
              class="widget-list widget-list-rounded"
              :class="{ 'inverse-mode': inverseMode }"
            >
              <!-- begin widget-table -->
              <div class="table-responsive" style="height: 500px;">
                <!-- begin widget-table -->
                <table
                  class="table table-bordered widget-table widget-table-rounded"
                  v-bind:class="{ 'inverse-mode': inverseMode }"
                >
                  <thead>
                    <tr>
                      <th
                        class="ts-sticky ts-top-0 ts-bg-gray-300 ts-whitespace-no-wrap"
                      >
                        Product Code
                      </th>
                      <th class="ts-sticky ts-top-0 ts-bg-gray-300">
                        Model
                      </th>
                      <th class="ts-sticky ts-top-0 ts-bg-gray-300">
                        Product Group
                      </th>
                      <th
                        class="ts-sticky ts-top-0 ts-bg-gray-300 ts-text-center"
                      >
                        Total Stock
                      </th>
                      <th
                        v-for="(w, index) in wareHouses"
                        :key="index"
                        class="ts-sticky ts-top-0 ts-bg-gray-300 ts-text-center"
                      >
                        {{ w.location_name_en }}
                      </th>
                    </tr>
                    <tr
                      v-if="
                        balanceInventoryByBranch.length > 0 &&
                          wareHouses.length > 0
                      "
                    >
                      <th colspan="3" class="ts-text-right">
                        Total
                      </th>
                      <th class="ts-text-center">
                        {{ totalStock() }}
                      </th>
                      <th
                        v-for="(w, index) in wareHouses"
                        :key="index"
                        class="ts-text-center"
                      >
                        {{ totalByWareHouse(w.location_id) }}
                      </th>
                    </tr>
                    <tr v-for="(pg, index) in proGroup" :key="index">
                      <th colspan="3" class="ts-text-right">
                        Total ({{ index != 'null' ? index : 'Not Assign' }})
                      </th>
                      <th class="ts-text-center">
                        {{ totalStockByGroup(pg) }}
                      </th>
                      <th
                        v-for="(w, index) in wareHouses"
                        :key="index"
                        class="ts-text-center"
                      >
                        {{ totalStockByGroupWareHouse(pg, w.location_id) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(record, index) in balanceInventoryByBranch"
                      :key="index"
                    >
                      <td>
                        {{ record.barcode }}
                      </td>
                      <td>
                        {{ record.product_name_en }}
                      </td>
                      <td>
                        {{ record.pro_group_name_en }}
                      </td>
                      <td class="ts-text-center">
                        {{ totalStockByProduct(record) }}
                      </td>
                      <td
                        v-for="(w, index) in wareHouses"
                        :key="index"
                        class="ts-text-center"
                      >
                        {{
                          productWareHouse(
                            record.product_location,
                            w.location_id
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- end widget-table -->
              </div>
              <!-- end table-responsive -->
            </div>
          </ts-loading-banner>
          <!-- end widget-list -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: ['inverseMode'],
  data () {
    return {
      loading: false,
      wareHouses: [],
      productGroups: [],
      balanceInventoryByBranch: [],
      branchList: [{ label: 'Sad', value: 'sad' }],
      model: {
        pro_group_id: []
      }
    }
  },
  filters: {
    format_number (value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  computed: {
    proGroup () {
      return _.groupBy(this.balanceInventoryByBranch, 'pro_group_name_en')
    }
  },
  methods: {
    ...mapActions('dashboard/widget', [
      'fetchBalanceInventoryByBranch',
      'fetchWareHouses',
      'getProductGroup'
    ]),
    moment,
    totalStockByGroup (pg) {
      let total = 0
      pg.forEach(e => {
        total = total + _.sumBy(e.product_location, 'current_stock')
      })
      return total
    },
    totalStockByGroupWareHouse (pg, location_id) {
      let total = 0
      pg.forEach(e => {
        let stock = e.product_location.find(el => el.location_id == location_id)
        total =
          total + (stock ? (stock.current_stock ? stock.current_stock : 0) : 0)
      })
      return total
    },
    totalStock () {
      let total = 0
      this.balanceInventoryByBranch.forEach(e => {
        total = total + _.sumBy(e.product_location, 'current_stock')
      })
      return total
    },
    totalByWareHouse (location_id) {
      var total = 0
      this.balanceInventoryByBranch.forEach(e => {
        var stock = e.product_location.find(el => el.location_id == location_id)
        total =
          total + (stock ? (stock.current_stock ? stock.current_stock : 0) : 0)
      })
      return total
    },
    totalStockByProduct (record) {
      let total = _.sumBy(record.product_location, 'current_stock')
      return total ? total : 0
    },
    productWareHouse (record, location_id) {
      let stock = record.find(e => e.location_id == location_id)
      return stock ? (stock.current_stock ? stock.current_stock : 0) : 0
    },
    async fetchResource () {
      this.loading = true
      await this.fetchWareHouses()
        .then(responses => {
          this.wareHouses = responses
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
      await this.getProductGroup()
        .then(responses => {
          this.productGroups = responses.map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
        })
        .catch(() => {
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
      this.fetchData()
    },
    async fetchData () {
      this.loading = true
      await this.fetchBalanceInventoryByBranch(this.model)
        .then(responses => {
          this.balanceInventoryByBranch = responses
        })
        .catch(() => {
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    'model.pro_group_id': debounce(function () {
      this.fetchData()
    }, 500)
  }
}
</script>
<style scoped>
.bg-dark-darker {
  background-color: #22282d !important;
}
</style>
